import { render, staticRenderFns } from "./OutboundCampaignDetail.vue?vue&type=template&id=929d6a18&scoped=true"
import script from "./OutboundCampaignDetail.vue?vue&type=script&lang=js"
export * from "./OutboundCampaignDetail.vue?vue&type=script&lang=js"
import style0 from "./OutboundCampaignDetail.vue?vue&type=style&index=0&id=929d6a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929d6a18",
  null
  
)

export default component.exports